/** P(D|+) = P(+|D)·P(D) / (P(+|D)·P(D) + P(+|¬D)·P(¬D)). */
export function bayesPosterior(prior: number, sens: number, fpr: number): number {
  const num = sens * prior;
  const denom = num + fpr * (1 - prior);
  if (denom === 0) return 0;
  return num / denom;
}

export function isIndependent(pA: number, pB: number, pAB: number, epsilon = 1e-6): boolean {
  if (pA === 0 || pB === 0) return false;
  return Math.abs(pAB - pA * pB) <= epsilon;
}
